import { render, staticRenderFns } from "./channels-add-or-update.vue?vue&type=template&id=7690f3c6&scoped=true&"
import script from "./channels-add-or-update.vue?vue&type=script&lang=js&"
export * from "./channels-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./channels-add-or-update.vue?vue&type=style&index=0&id=7690f3c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7690f3c6",
  null
  
)

export default component.exports